import React from "react";
import SectionHeader from "./SectionHeader";
import InputField from "./../common/InputField";

function AddressSection() {
  return (
    <section className="mt-6 w-full max-md:max-w-full">
      <SectionHeader icon="personalcard" title="Address details" />
      <div className="mt-4 w-full text-sm leading-loose max-md:max-w-full">
        <InputField
          label="Street"
          placeholder="Street"
          className="w-full whitespace-nowrap min-h-16 max-md:max-w-full"
        />
        <div className="flex flex-wrap gap-6 items-start mt-6 w-full max-md:max-w-full">
          <InputField
            label="Location"
            placeholder="Location"
            className="flex-1 shrink whitespace-nowrap basis-0 min-w-60 max-md:max-w-full"
          />
          <InputField
            label="Postal code"
            placeholder="Postal code"
            className="w-[200px]"
          />
        </div>
        <InputField
          label="country"
          placeholder="Please select"
          required
          dropdown
          className="mt-6 w-full min-h-16 max-md:max-w-full"
        />
        <InputField
          label="Telephone number"
          placeholder="Telephone number"
          className="mt-6 w-full min-h-16 max-md:max-w-full"
        />
      </div>
    </section>
  );
}

export default AddressSection;
